let rightData = [
  {
    source: { id: null, name: "Yahoo Entertainment" },
    author: "Robert Brand and Stephen Kirkland",
    title:
      "US Stocks Drop With Bonds as Brutal Year Nears End: Markets Wrap - Yahoo Finance",
    description:
      "(Bloomberg) -- US stocks declined on the final trading day of 2022 as financial markets close out the worst year in more than a decade for global equities...",
    url: "https://finance.yahoo.com/news/asia-stocks-rise-p-500-233248167.html",
    urlToImage:
      "https://s.yimg.com/ny/api/res/1.2/Vgrt.ZTT0oyTKJ7deVaQFA--/YXBwaWQ9aGlnaGxhbmRlcjt3PTEyMDA7aD04MDA-/https://media.zenfs.com/en/bloomberg_markets_842/66eb684edb974176d2a840428be7b9e8",
    publishedAt: "2022-12-30T14:31:22Z",
    content:
      "(Bloomberg) -- US stocks declined on the final trading day of 2022 as financial markets close out the worst year in more than a decade for global equities and bonds.\r\nMost Read from Bloomberg\r\nThe S&… [+3422 chars]",
  },
  {
    source: { id: null, name: "CNBC" },
    author: "Ryan Browne",
    title:
      "Bahamian regulator says it seized $3.5 billion of FTX crypto assets for 'safekeeping' - CNBC",
    description:
      "The Securities Commission of The Bahamas said it moved $3.5 billion from FTX's Bahamian subsidiary, FTX Digital Markets, into its own digital wallets.",
    url: "https://www.cnbc.com/2022/12/30/bahamas-regulator-seized-3point5-billion-of-ftx-crypto-assets.html",
    urlToImage:
      "https://image.cnbcfm.com/api/v1/image/107172502-1672395351694-gettyimages-1245052550-FTX_ILLO.jpeg?v=1672404741&w=1920&h=1080",
    publishedAt: "2022-12-30T12:52:21Z",
    content:
      "The Securities Commission of The Bahamas says it seized $3.5 billion worth of cryptocurrency from collapsed crypto exchange FTX.\r\nIn a media release late Thursday, the watchdog confirmed the total su… [+2251 chars]",
  },
  {
    source: { id: null, name: "CNBC" },
    author: "Peter Schacknow",
    title:
      "Stocks making the biggest moves premarket: Shaw Communications, Li Auto, Southwest and others - CNBC",
    description:
      "These are the stocks posting the largest moves before the bell.",
    url: "https://www.cnbc.com/2022/12/30/stocks-making-the-biggest-moves-premarket-shaw-communications-li-auto-southwest-and-others.html",
    urlToImage:
      "https://image.cnbcfm.com/api/v1/image/106841126-16135104622021-02-16t204145z_1290440652_rc2wtl9euyvu_rtrmadp_0_usa-stocks.jpeg?v=1672404514&w=1920&h=1080",
    publishedAt: "2022-12-30T12:48:34Z",
    content:
      "Check out the companies making headlines before the bell:\r\nShaw Communications (SJR) Canada's Competition Tribunal dismissed an attempt by the country's competition watchdog to block the $26 billion … [+1465 chars]",
  },
  {
    source: { id: null, name: "CNBC" },
    author: "Jesse Pound, Samantha Subin",
    title:
      "Stock futures edge lower as Wall Street awaits final trading day of 2022 - CNBC",
    description:
      "Stocks are on pace to snap a three-year win streak and finish their worst year since 2008.",
    url: "https://www.cnbc.com/2022/12/29/stock-market-futures-open-to-close-news.html",
    urlToImage:
      "https://image.cnbcfm.com/api/v1/image/107172157-1672320963293-trad.jpg?v=1672380744&w=1920&h=1080",
    publishedAt: "2022-12-30T12:43:00Z",
    content:
      "Stock futures edged lower in premarket trading Friday as investors braced for the final trading day of the worst year for stocks since 2008.\r\nFutures tied to the Dow Jones Industrial Average slipped … [+2877 chars]",
  },
  {
    source: { id: null, name: "BBC News" },
    author: "https://www.facebook.com/bbcnews",
    title: "Hershey sued in US over metal in dark chocolate claim - BBC",
    description:
      "The lawsuit alleges that three Hershey products contain harmful levels of lead and cadmium.",
    url: "https://www.bbc.com/news/business-64123157",
    urlToImage:
      "https://ichef.bbci.co.uk/news/1024/branded_news/4DDF/production/_128153991_7ad82c3ef6b27b0d6ff8d7880758d76ffd47936c.jpg",
    publishedAt: "2022-12-30T10:30:37Z",
    content:
      "Chocolate manufacturer Hershey has been sued in the US over claims the firm is selling products containing harmful levels of metal.\r\nThe lawsuit brought by Christopher Lazazzaro alleges the firm misl… [+2322 chars]",
  },
];
export default rightData;
